import React from 'react';
import Navbar from '../components/Navbar';

function NavbarContainer() {
  return <Navbar />;
}

export default NavbarContainer;
